// src/components/Footer.tsx
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-dark text-light py-4 mt-auto">
      <Container>
        <Row>
          <Col md={6} className="mb-3 mb-md-0">
            <h5>Sociedade Amigos de Coqueiros</h5>
            <p className="mb-0">Sistema de Controle de Tarifas de Água</p>
            <p className="small text-muted">© {currentYear} Todos os direitos reservados</p>
          </Col>
          <Col md={3} className="mb-3 mb-md-0">
            <h6>Links Rápidos</h6>
            <ul className="list-unstyled">
              <li><a href="/" className="text-light text-decoration-none">Início</a></li>
              <li><a href="/about" className="text-light text-decoration-none">Sobre</a></li>
              <li><a href="/contact" className="text-light text-decoration-none">Contato</a></li>
            </ul>
          </Col>
          <Col md={3}>
            <h6>Contato</h6>
            <address className="mb-0 text-light">
              <p className="mb-1">Avenida Presidente Vargas, SN, Centro</p>
              <p className="mb-1">Coqueiros do Sul</p>
              <p className="mb-1">alanpetry@alnet.eti.br</p>
              <p className="mb-0">(54) 98415-0888</p>
            </address>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;